// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-dropdown-select-input {
  min-height: 25px !important;
  padding: 0 !important;
  border-top: none !important;
  border-right: none !important;
  border-left: none !important;
  border-color: var(--color-grayscale-4) !important;
  box-shadow: none !important;
  cursor: pointer;
}

  .app-dropdown-select-input input {
    margin: 0;
    font-size: 14px;
    border-bottom: 0 !important;
  }

  .app-dropdown-select-input svg {
    color: var(--color-grayscale-4);
    height: 14px;
  }

  .app-dropdown-select-input--selected {
    border-color: var(--color-green-6) !important;
  }

  .app-dropdown-select-input__clear-btn {
    padding: 0;
    min-width: 24px;
    min-height: 20px;
  }

  .app-dropdown-select-input__async-dd {
    display: flex;
    height: 24px !important;
    padding: 0 !important;
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-color: var(--color-grayscale-4) !important;
    box-shadow: none !important;
    cursor: pointer;
    border-bottom: 1px solid rgb(204 204 204);
    justify-content: space-between;
    align-items: center;
    color: var(--color-grayscale-6);
  }

  .app-dropdown-select-input__async-dd-btn {
      padding: 0 !important;
      min-height: 0;
      min-width: 16px;
      border: 0;
      height: 100%;
      background: transparent;
    }

  .app-dropdown-select-input__async-dd-btn svg {
        color: var(--color-grayscale-4);
        height: 16px;
      }

.react-dropdown-select-item-active {
  box-shadow: inset 0 0 0 2px var(--color-green-8);
}

/* .react-dropdown-select-item {
  display: flex;
  align-items: center;
} */
`, "",{"version":3,"sources":["webpack://./app/components/DropdownSelectInput/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,iDAAiD;EACjD,2BAA2B;EAC3B,eAAe;AAqDjB;;EAnDE;IACE,SAAS;IACT,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,iDAAiD;IACjD,2BAA2B;IAC3B,eAAe;IACf,yCAAyC;IACzC,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;EAgBjC;;EAbE;MACE,qBAAqB;MACrB,aAAa;MACb,eAAe;MACf,SAAS;MACT,YAAY;MACZ,uBAAuB;IAMzB;;EAJE;QACE,+BAA+B;QAC/B,YAAY;MACd;;AAKN;EACE,gDAAgD;AAClD;;AAEA;;;GAGG","sourcesContent":[".app-dropdown-select-input {\n  min-height: 25px !important;\n  padding: 0 !important;\n  border-top: none !important;\n  border-right: none !important;\n  border-left: none !important;\n  border-color: var(--color-grayscale-4) !important;\n  box-shadow: none !important;\n  cursor: pointer;\n\n  & input {\n    margin: 0;\n    font-size: 14px;\n    border-bottom: 0 !important;\n  }\n\n  & svg {\n    color: var(--color-grayscale-4);\n    height: 14px;\n  }\n\n  &--selected {\n    border-color: var(--color-green-6) !important;\n  }\n\n  &__clear-btn {\n    padding: 0;\n    min-width: 24px;\n    min-height: 20px;\n  }\n\n  &__async-dd {\n    display: flex;\n    height: 24px !important;\n    padding: 0 !important;\n    border-top: none !important;\n    border-right: none !important;\n    border-left: none !important;\n    border-color: var(--color-grayscale-4) !important;\n    box-shadow: none !important;\n    cursor: pointer;\n    border-bottom: 1px solid rgb(204 204 204);\n    justify-content: space-between;\n    align-items: center;\n    color: var(--color-grayscale-6);\n\n\n    &-btn {\n      padding: 0 !important;\n      min-height: 0;\n      min-width: 16px;\n      border: 0;\n      height: 100%;\n      background: transparent;\n\n      & svg {\n        color: var(--color-grayscale-4);\n        height: 16px;\n      }\n    }\n  }\n}\n\n.react-dropdown-select-item-active {\n  box-shadow: inset 0 0 0 2px var(--color-green-8);\n}\n\n/* .react-dropdown-select-item {\n  display: flex;\n  align-items: center;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
